import type { ReactNode } from "react";

import LandingFooter from "../LandingPage/LandingFooter";
import LandingNavbar from "../LandingPage/LandingNavbar";

import "../LandingPage/LandingPage.css";
import "./legalDocument.css";

type LegalPublicLayoutProps = {
  children: ReactNode;
};

/**
 * Shell for legal pages: same background, nav and footer as the marketing landing.
 */
export default function LegalPublicLayout({ children }: LegalPublicLayoutProps) {
  return (
    <div className="landing-page">
      <div className="landing-page__glow landing-page__glow--left" aria-hidden="true" />
      <div className="landing-page__glow landing-page__glow--right" aria-hidden="true" />

      <LandingNavbar />

      {children}

      <LandingFooter />
    </div>
  );
}
